import React from 'react';
import {Modal} from 'antd';
import {EmailPreview} from '../../components/TicketGroup/View/EmailPreview';
import {EmailPreviewHeader} from '../../components/TicketGroup/View/EmailPreviewHeader';
import {useEmailPreviewActions} from '../../hooks/emailPreview';
import {getEmailPreview} from '../../queries/ticketGroup';
import {EmailPreviewT} from '../../types/tickets';

export const useEmailPreview = (groupId?: number) => {
  const loadEmailPreview = async (guestId?: string) => {
    if (!guestId || !groupId) return;
    try {
      const res = await getEmailPreview({groupId: String(groupId), guestId: guestId});
      const preview = res?.body as EmailPreviewT;

      // Create a component that uses the hook
      const HeaderWithActions = () => {
        const {handleCopyEmail, handleSavePDF} = useEmailPreviewActions(preview);
        return <EmailPreviewHeader onCopyEmail={handleCopyEmail} onSavePDF={handleSavePDF} />;
      };

      Modal.info({
        title: <HeaderWithActions />,
        content: (
          <EmailPreview emailBody={preview.emailBody} subject={preview.subject} from={preview.from} to={preview.to} />
        ),
        okButtonProps: {
          style: {
            display: 'none',
          },
        },
        closable: true,
        className: 'preview',
      });
    } catch (error) {}
  };

  return {loadEmailPreview};
};
